
/*
|--------------------------------------------------------------------------
| Custom Javascript code
|--------------------------------------------------------------------------
|
| Now that you configured your website, you can write additional Javascript
| code inside the following function. You might want to add more plugins and
| initialize them in this file.
|
*/

$(function() {

    

});

document.addEventListener("DOMContentLoaded", function() {
    
    // Function to check if an element with a given ID exists
    function elementExists(id) {return document.querySelector(id) !== null}

    // Check if the elements with the specified IDs exist before modifying them
    if (elementExists('#navbar')) {
        fetch('./assets/includes/navbar.html')
        .then(response => {return response.text()})
        .then(data => {document.querySelector('#navbar').innerHTML = data})
    }

    if (elementExists('#navbar-light')) {
        fetch('./assets/includes/navbar-light.html')
        .then(response => {return response.text()})
        .then(data => {document.querySelector('#navbar-light').innerHTML = data})
    }

    if (elementExists('#footer')) {
        fetch('./assets/includes/footer.html')
        .then(response => {return response.text()})
        .then(data => {document.querySelector('#footer').innerHTML = data})
    }

})
